import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL


export function validartoken(body:any) {
    return axios.post(API_URL+'/validar_token_recovery',body)
  }
